module.exports = __webpack_public_path__ + "static/media/1.aa8cef3f.jpg";